import React from 'react';

import classnames from 'classnames';

import { Tag } from '@components/atoms/tag';
import { Button } from '@components/atoms/button';

import { LoadIcon } from '@svgs';

import styles from './styles.module.scss';

export const PlanCard = ({
  title,
  price,
  discount,
  foundersAccess = false,
  onSelect,
  isPlusUser = false,
  dominant
}) => {
  return (
    <div
      className={classnames(
        `${styles.planCard}`, `${dominant ? styles.dominant : ''}`
      )}
    > 

      {foundersAccess && 
        <span className={styles.foundersBadge}>
          <LoadIcon name="FoundersBadge" />
        </span>
      }

      <div className={styles.cardHeader}>
        <h3 className={styles.title}>
          {title}
          {discount &&
            <Tag type="yellow" shape="pill" >£{discount} Discount</Tag>
          }
        </h3 >
        <h2 className={styles.price}>£{price}<span className={styles.vatText}>(Inc VAT)</span></h2>
      </div>

      {foundersAccess &&
        <div className={styles.foundersBenefits}>
          <p className={styles.foundersTitle}>Founders Club benefits:</p>
          <ul className={styles.foundersList}>
            <li>Have your say: Feedback and requests prioritised</li>
            <li>Priority support: You&apos;re first in line for our assistance</li>
          </ul>
        </div>
      }

      <div className={styles.features}>
        <p className={styles.featuresTitle}>Instant access to:</p>
        <ul>
          <li className={`${styles.grantedFeature}`}><LoadIcon name="Tick" /> PDF job reports</li>
          <li className={`${styles.grantedFeature}`}><LoadIcon name="Tick" /> Excel & PDF timesheets</li>
          {/* <li className={`${styles.grantedFeature}`}><LoadIcon name="Tick" /> Desktop access to Yepic</li> */}
          <li className={`${styles.grantedFeature}`}><LoadIcon name="Tick" /> Add unlimited teammates to jobs</li>
          {!foundersAccess &&
              <li className={styles.missingFeature}><LoadIcon name="Cross" /> Access to the Founders Club</li>
          }
        </ul>
      </div>

      <div className={styles.planButton} data-testid={`select-${title.toLowerCase()}-plan-btn`}>
        <Button 
          type={dominant ? 'primary' : 'secondary'}
          onClick={onSelect} where='Plans Page'
          actionLabel={`Create ${title} Plan`}
        >
          {!isPlusUser ? 'Select Plan' : 'Manage my plan'}
        </Button>
      </div>
    </div >
  );
};
